import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FormattedMessage } from '@techstyle/react-intl';

import { ReviewSortCategories } from '../../constants/reviews';
import { BasicButton } from '../../styles/button';

const SortReviewsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 0 0 50%;
  width: 100%;
`;

const FilterButton = styled(BasicButton)`
  min-width: 0px;

  &:last-of-type {
    margin-right: 0;
  }
`;

function SortReviews({ className, onChange, reviewSortCategory }) {
  const handleClick = useCallback(
    _reviewSortCategory => {
      return () => {
        onChange(_reviewSortCategory);
      };
    },
    [onChange]
  );

  return (
    <SortReviewsWrapper className={className}>
      <FilterButton
        selected={reviewSortCategory === ReviewSortCategories.HIGHEST_RATED}
        variant={
          reviewSortCategory === ReviewSortCategories.HIGHEST_RATED
            ? 'tertiaryDark'
            : 'tertiaryLight'
        }
        onClick={handleClick(ReviewSortCategories.HIGHEST_RATED)}
      >
        <FormattedMessage
          id="site_pdp.sort_highest_rated"
          defaultMessage="Highest Rated"
        />
      </FilterButton>

      <FilterButton
        selected={reviewSortCategory === ReviewSortCategories.LOWEST_RATED}
        variant={
          reviewSortCategory === ReviewSortCategories.LOWEST_RATED
            ? 'tertiaryDark'
            : 'tertiaryLight'
        }
        onClick={handleClick(ReviewSortCategories.LOWEST_RATED)}
      >
        <FormattedMessage
          id="site_pdp.sort_lowest_rated"
          defaultMessage="Lowest Rated"
        />
      </FilterButton>

      <FilterButton
        selected={reviewSortCategory === ReviewSortCategories.MOST_RECENT}
        variant={
          reviewSortCategory === ReviewSortCategories.MOST_RECENT
            ? 'tertiaryDark'
            : 'tertiaryLight'
        }
        onClick={handleClick(ReviewSortCategories.MOST_RECENT)}
      >
        <FormattedMessage
          id="site_pdp.sort_most_recent"
          defaultMessage="Most Recent"
        />
      </FilterButton>
    </SortReviewsWrapper>
  );
}

SortReviews.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  reviewSortCategory: PropTypes.string,
};

export default SortReviews;
